import { Menu } from '@headlessui/react';
import { ReactNode } from 'react';
import Icon, { IconSize } from './icon.component';

export interface OptionsMenuItemProps {
  onClick?: () => void;
  icon?: string;
  children: ReactNode;
}

const OptionsMenuItem = ({ onClick, children, icon }: OptionsMenuItemProps) => {
  return (
    <Menu.Item>
      <span
        className="block hover:bg-gray-100 px-4 py-2 text-sm text-gray-700 cursor-pointer flex flex-row items-center"
        onClick={onClick}
      >
        {!!icon && <Icon className="mr-2" name={icon} size={IconSize.Small} />}
        {children}
      </span>
    </Menu.Item>
  );
};

export default OptionsMenuItem;
